
<template>
  <div class="tabs-bar-wrapper" :class="className">
    <div ref="tabsBar" class="tabs-bar">
      <ul class="tabs-nav">
        <li
          v-for="(title, index) in tabtitles"
          :class="[title.id === activeId ? 'active' : '']"
          :style="{ width: tabWidth, padding: tabPadding}"
          :key="title.id"
          @click="changeTab(title.id, index)"
        >
          <span :ref="`name_${title.id}`">{{title.name}}</span>
        </li>
        <div class="tab-ink-bar-wrapper" :style="{ transform: inkBarPosition, webkitTransform: inkBarPosition, width: tabWidth, padding: tabPadding }">
          <span class="tab-ink-bar" :style="{width: inkWidth}"></span>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tab-bar',
  props: {
    tabtitles: {
      type: Array,
      required: true,
    },
    defaultActiveId: [String, Number],
    className: String,
    maxTitleNum: {
      type: Number,
      default: 4,
    },
    titleWidth: {
      type: Number,
      default: 80,
    },
    fixPadding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeId: this.defaultActiveId || '',
      tabsBarPosition: '',
      isMounted: false,
      inkWidth: '0px',
    }
  },
  watch: {
    defaultActiveId(n, o) {
      this.activeId = n
    },
    tabtitles(n, o) {
      if (this.activeId == '' && n !== o && n.length) {
        this.activeId = n[0].id
      }
    },
  },
  computed: {
    activeIndex() {
      return this.tabtitles.findIndex(el => el.id === this.activeId)
    },
    inkBarPosition() {
      return `translate3d(${100 * this.activeIndex}%, 0px, 0px)`
    },
    tabWidth() {
      if (this.fixPadding) {
        return ''
      }
      if (!this.tabtitles.length) {
        return ''
      }
      if (this.tabtitles.length <= this.maxTitleNum) {
        return `${100 / this.tabtitles.length}%`
      } else {
        return `${this.titleWidth}px`
      }
    },
    tabPadding() {
      if (this.fixPadding) {
        return '0 15px'
      }
      return ''
    },
  },
  updated() {
    const index = `name_${this.activeId}`
    if (this.tabtitles && this.$refs[index] && this.$refs[index].length) {
      this.inkWidth = `${this.$refs[index][0].offsetWidth}px`
    }
  },
  mounted() {
    this.isMounted = true
    const index = `name_${this.activeId}`
    const ref = this.$refs[index]
    if (ref) {
      this.inkWidth = `${ref[0].offsetWidth}px`
    }
  },
  methods: {
    changeTab(id, index) {
      if (this.activeId !== id) {
        this.activeId = id
      }
      this.checkTabsBarPosition()
      this.$emit('changeTab', this.activeId)
    },
    checkTabsBarPosition() {
      if (this.tabtitles.length <= this.maxTitleNum) {
        return
      }
      const scrollLeft = this.$refs.tabsBar.scrollLeft
      const activeTab = this.activeIndex + 1
      const possiblePosition = Array.from({ length: activeTab > this.maxTitleNum ? this.maxTitleNum : activeTab }, (v, i) => activeTab - i)
      const minScrollLeft = possiblePosition.reduce((min, pos) => {
        const csl = (pos - 1) * this.titleWidth
        return Math.abs(csl - scrollLeft) < Math.abs(min - scrollLeft) ? csl : min
      }, this.maxTitleNum * this.titleWidth + scrollLeft)
      this.$refs.tabsBar.scrollLeft = minScrollLeft
    },
  },
}
</script>

<style lang="less">
@import '../../stylesheet/variable';

@inkGrey: rgb(25, 26, 27);
@silverGrey: rgb(237, 237, 237);
@reddish: rgb(192, 49, 49);

.tabs-bar-wrapper {
  position: relative;
  z-index: 100;
  width: 100%;
  overflow-x: hidden;
  background: #fff;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  a {
    text-decoration: none;
  }
  ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .tabs-bar {
    height: 49px;
    display: flex;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    transition: transform 0.2s cubic-bezier(0.35, 0, 0.25, 1);
    position: relative;
    &::-webkit-scrollbar {
      display: none;
    }
    &::after {
      .setBottomLine();
    }
    .tabs-nav {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      width: 100%;
      li {
        flex-shrink: 0;
        -webkit-flex-shrink: 0;
        color: @inkGrey;
        text-align: center;
        height: 16px;
        line-height: 16px;
        font-size: 14px;
        cursor: pointer;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
      li.active {
        color: @orange;
      }

      .tab-ink-bar-wrapper {
        position: absolute;
        margin: auto;
        top: 30px;
        left: 0;
        transform: translate3d(0px, 0px, 0px);
        transition: transform 0.2s cubic-bezier(0.35, 0, 0.25, 1);
        .tab-ink-bar {
          border-bottom: 2px solid @orange;
          border-radius: 20px;
          display: block;
          margin: auto;
        }
      }
    }
  }
}
</style>
